<template>
  <div>
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-model-item label="申请人名称" prop="applicantName">
          <a-input
            v-model="form.applicantName"
            placeholder="请输入申请人名称"
            :disabled="true"
          />
        </a-form-model-item>
      </a-col>

      <a-col :span="12">
        <a-form-model-item label="手机号" prop="applicantPhone">
          <a-input
            v-model="form.applicantPhone"
            placeholder="请输入手机号"
            :disabled="true"
          />
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-model-item label="申请企业名称" prop="applyingBusiness">
          <a-input
            v-model="form.applyingBusiness"
            placeholder="请输入申请企业名称"
            :disabled="true"
          />
        </a-form-model-item>
      </a-col>

      <a-col :span="12">
        <a-form-model-item
          label="申请企业统一社会信用代码"
          prop="applyingBusinessCreditCode"
        >
          <a-input
            v-model="form.applyingBusinessCreditCode"
            placeholder="请输入申请企业统一社会信用代码"
            :disabled="true"
          />
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-model-item label="是否国资" prop="stateOwnedEnterprises">
          <a-radio-group v-model="form.stateOwnedEnterprises" :disabled="true">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-col>

      <a-col :span="12">
        <a-form-model-item label="申请人经济类型" prop="applyingEconomicType">
          <a-select
            placeholder="请选择申请人经济类型"
            v-model="form.applyingEconomicType"
            :not-found-content="fetching.economicType ? undefined : null"
            :disabled="true"
          >
            <a-spin
              v-if="fetching.economicType"
              slot="notFoundContent"
              size="small"
            />
            <a-select-option
              v-else
              v-for="applyingEconomicType in dictionaries.economicType"
              :key="applyingEconomicType.value"
            >
              {{ applyingEconomicType.note }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row :gutter="24" v-if="form.stateOwnedEnterprises == 1 || form.applyingEconomicType === 'A050070001'">
      <a-col :span="12">
        <a-form-model-item label="申请人所属集团" prop="obligeeEnterpriseName">
          <a-tree-select
              v-model="form.obligeeEnterpriseName"
              show-search
              labelInValue
              :tree-data="affiliatedTreeData"
              :expandedKeys="treeExpandedKeys"
              :autoExpandParent="true"
              :filterTreeNode="false"
              @search="onAffiliatedTreeSearch"
              :searchValue="affiliatedTreeSearchValue"
              style="width: 100%"
              placeholder="请选择申请人所属集团"
              searchPlaceholder="请输入需要查询的集团名称"
              :disabled="true"
              dropdownMatchSelectWidth
              :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
            >
              <a-spin
                v-if="affiliatedTreeLoading"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
        </a-form-model-item>
      </a-col>

      <a-col :span="12">
        <a-form-model-item
          label="申请人监管部门"
          prop="applyingRegulatoryAuthority"
        >
          <a-tree-select
              v-model="form.applyingRegulatoryAuthority"
              show-search
              labelInValue
              :tree-data="regulatoryTreeData"
              :expandedKeys="treeExpandedKeys"
              :autoExpandParent="true"
              :filterTreeNode="false"
              @search="onRegulatoryTreeSearch"
              :searchValue="regulatoryTreeSearchValue"
              style="width: 100%"
              placeholder="请选择申请人监管部门"
              searchPlaceholder="请输入需要查询的监管部门"
              :disabled="true"
              dropdownMatchSelectWidth
              :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
            >
              <a-spin
                v-if="regulatoryTreeLoading"
                slot="notFoundContent"
                size="small"
              />
            </a-tree-select>
        </a-form-model-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getEconomicType, getOrgTree, getOrgList, } from "@/api/shexgrp/Dictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      fetching: {
        economicType: false,
      },
      dictionaries: {
        economicType: [],
      },
      affiliatedOriginTreeData: [],
      regulatoryOriginTreeData: [],
      affiliatedTreeLoading: false,
      regulatoryTreeLoading: false,
      affiliatedTreeData: [],
      regulatoryTreeData: [],
      affiliatedTreeSearchValue: "",
      regulatoryTreeSearchValue: "",
      treeExpandedKeys: [],
    };
  },
  mounted(){
    //获取经济类型字典
    this.obligeeEconomicTypeDictionaries()
    this.handleAffiliatedTreeVisible()
    this.handleRegulatoryTreeVisible()
  },
  methods: {
    //经济类型字典
    obligeeEconomicTypeDictionaries() {
      // 已有数据则不再请求
      if (this.dictionaries.economicType.length > 0) return;
      //获取字典内容
      this.fetching.economicType = true;
      getEconomicType()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.economicType = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.economicType = false;
        });
    },

    //点击所属集团树搜索下拉框
    async handleAffiliatedTreeVisible() {
      // 已加载过，直接用
      if (this.affiliatedOriginTreeData.length > 0) {
        this.affiliatedTreeSearchValue = "";
        // 重置树展示
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        return;
      }
      //首次加载，调用后端接口获取联交所 所属企业字典
      this.affiliatedTreeLoading = true;
      try {
        const res = await getOrgTree();
        if (res.code !== "200") return;
        //将后端树结构映射成ant-vue的书接口
        const tree = this.mapToAffiliatedTreeSelect(res.data);

        this.affiliatedOriginTreeData = tree;
        this.affiliatedTreeData = tree;
      } catch (e) {
        console.error("所属集团树加载失败", e);
      } finally {
        this.affiliatedTreeLoading = false;
      }
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToAffiliatedTreeSelect(data = [], parentKey = "") {
      return data.map((item, index) => {
        const currentKey = item.ID;

        const children = Array.isArray(item.children)
          ? this.mapToAffiliatedTreeSelect(item.children, currentKey)
          : [];

        // ⭐ 核心业务规则
        const canSelect = String(item.FILL_TYPE_CODE) === "2";

        return {
          title: item.NAME || item.CODE,
          key: currentKey,
          value: currentKey, // 只用于 TreeSelect 唯一标识
          // 是否可选，完全由业务字段决定
          selectable: canSelect,
          disabled: !canSelect,
          children,
        };
      });
    },
    //搜索树结构内容
    onAffiliatedTreeSearch(value) {
      this.affiliatedTreeSearchValue = value;

      if (!value) {
        // 清空搜索 → 恢复完整树
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        this.treeExpandedKeys = ["ROOT"];
        return;
      }

      const expandedKeys = [];
      const filteredTree = this.filterTreeByKeyword(
        this.affiliatedOriginTreeData,
        value,
        expandedKeys
      );

      this.affiliatedTreeData = filteredTree;
      this.treeExpandedKeys = expandedKeys;
    },

    //点击监管部门树搜索下拉框
    async handleRegulatoryTreeVisible() {
      // 已加载过，直接用
      if (this.regulatoryOriginTreeData.length > 0) {
        this.regulatoryTreeSearchValue = "";
        // 重置树展示
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        return;
      }
      //首次加载，调用后端接口获取联交所 所属企业字典
      this.regulatoryTreeLoading = true;
      try {
        const res = await getOrgList();
        if (res.code !== "200") return;
        //将后端树结构映射成ant-vue的书接口
        const tree = this.mapToRegulatoryListSelect(res.data);
        this.regulatoryOriginTreeData = tree;
        this.regulatoryTreeData = tree;
      } catch (e) {
        console.error("监管部门加载失败", e);
      } finally {
        this.regulatoryTreeLoading = false;
      }
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToRegulatoryListSelect(data = []) {
      const seenCode = new Set();

      return (
        data
          // ① 业务过滤：只保留可选组织
          .filter((item) => String(item.FILL_TYPE_CODE) !== "1")
          // ② CODE 去重：只保留第一次出现的
          .filter((item) => {
            if (seenCode.has(item.CODE)) return false;
            seenCode.add(item.CODE);
            return true;
          })
          // ③ 标准化映射
          .map((item) => ({
            key: item.ID,
            title: item.NAME,
            value: item.CODE,
          }))
      );
    },

    // 搜索监管部门（兼容 list / tree）
    onRegulatoryTreeSearch(value) {
      this.regulatoryTreeSearchValue = value;

      if (!value) {
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        this.regulatoryTreeExpandedKeys = [];
        return;
      }

      const expandedKeys = [];

      const filtered = this.filterTreeByKeyword(
        this.regulatoryOriginTreeData,
        value,
        expandedKeys
      );

      this.regulatoryTreeData = filtered;
      this.regulatoryTreeExpandedKeys = expandedKeys;
    },

    /**
     * 通用 Tree / List 模糊搜索
     * - 支持 tree / list
     * - 忽略大小写
     * - 自动维护 expandedKeys
     */
    filterTreeByKeyword(tree = [], keyword, expandedKeys = []) {
      const result = [];
      const searchText = (keyword || "").toLowerCase().trim();

      tree.forEach((node) => {
        const title = (node.title || "").toLowerCase();
        const titleMatch =
          title.includes(searchText) || this.fuzzyMatch(title, searchText);

        const hasChildren =
          Array.isArray(node.children) && node.children.length > 0;

        // ===== list 模式 =====
        if (!hasChildren) {
          if (titleMatch) {
            result.push({ ...node });
          }
          return;
        }

        // ===== tree 模式 =====
        const filteredChildren = this.filterTreeByKeyword(
          node.children,
          searchText,
          expandedKeys
        );

        if (titleMatch || filteredChildren.length > 0) {
          result.push({
            ...node,
            children: filteredChildren,
          });

          if (filteredChildren.length > 0) {
            expandedKeys.push(node.key);
          }
        }
      });

      return result;
    },

    //模糊查询组件
    fuzzyMatch(text, keyword) {
      let t = 0;
      for (let k = 0; k < keyword.length; k++) {
        t = text.indexOf(keyword[k], t);
        if (t === -1) return false;
        t++;
      }
      return true;
    },
  },
};
</script>

<style>
</style>